import * as React from 'react';
import { DataGrid, GridToolbar, GridColDef, GridSelectionModel, GridValueGetterParams } from '@material-ui/data-grid';
import { useEffect, useState } from 'react';
import deleteIcon from '../images/delete-icon.svg';
import TableSearch from './TableSearch';
import { useFetch } from '../hooks/useFetch';
import { useCookies } from 'react-cookie';
import { Skeleton } from '@material-ui/lab';
import { relative } from 'path';

const columns: GridColDef[] = [
    { field: 'id', headerName: 'Student ID', minWidth: 124},
    {
        field: 'fullName',
        headerName: 'Student Name',
        description: 'This column has a value getter and is not sortable.',
        width: 264,
        valueGetter: (params: GridValueGetterParams) =>
            `${params.getValue(params.id, 'title') || ''} ${params.getValue(params.id, 'firstName') || ''} ${params.getValue(params.id, 'lastName') || ''}`,
        
        sortable: false,
    },
];


export interface StudentProps {
    id: string;
    curriculumId: number;
    semesterId: number;
    title: string;
    firstName: string;
    lastName: string;
    studentStatus: string;
    studentStatusId: number;
}

interface StudentNameTableProps {
    courseId: number;
    semesterId: number;
    selectionModel: GridSelectionModel;
    setSelectionModel: any;
    setSnackbarMessage: any;
}

export default function StudentNameTable({ courseId, semesterId, selectionModel, setSelectionModel, setSnackbarMessage }: StudentNameTableProps) {
    const [cookies] = useCookies(['user'])

    const handleOnClickDelete = (index: any) => {
        const newSelectionModel = selectionModel.filter((id) => id !== index);
        setSelectionModel(newSelectionModel);
    }

    const { data, status, error, loading } = useFetch({
        url: `/Students?curriculumId=${courseId}&semesterId=${semesterId}`,
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${cookies?.user?.token}`
        }
    }, courseId, semesterId)

    const [rows, setRows] = useState<StudentProps[]>([]);
    const [originalRows, setOriginalRows] = useState<StudentProps[]>([]);
    const [searchKey, setSearchKey] = useState('');


    const handleSearch = (title: string) => {
        setSearchKey(title);
    }

    useEffect(() => {
        if (data) {
            setRows(data)
            setOriginalRows(data)
        }
    }, [data])

    useEffect(() => {
        if (error) {
            setSnackbarMessage({ message: status === 404 ? 'No students were found in this semester and curriculum.' : 'Something went wrong! Please try again.', severity: 'error' })
        }
    }, [error])


    useEffect(() => {
        if (searchKey !== "" && data) {
            const newRows = data.filter((row: StudentProps) => {
                const fullName = `${row.title} ${row.firstName} ${row.lastName}`
                return row.id.toLowerCase().includes(searchKey.toLowerCase()) || fullName.toLowerCase().includes(searchKey.toLowerCase())
            })
            setRows(newRows);
        } else {
            if (data) {
                setRows(data)
            }
        }
    }, [searchKey])

    return (
        <div className='AddStudentDialog-student-name-container'>
            {loading ? (<Skeleton variant="rect" width={'100%'} height={352} />) :
                (<div className='flex gap-dot5' style={{ flexDirection: 'column', width: '100%', position: 'relative' }}>
                    <TableSearch handleSearch={handleSearch} />
                    <div style={{ height: 304, position: 'relative' }}>
                        <DataGrid
                            rows={rows}
                            columns={columns}
                            rowHeight={40}
                            headerHeight={40}
                            checkboxSelection
                            disableColumnMenu
                            hideFooter
                            selectionModel={selectionModel}
                            onSelectionModelChange={(newSelectionModel) => {
                                if (newSelectionModel.length > selectionModel.length) {
                                    const newSelection = newSelectionModel.filter((id: any) => !selectionModel.includes(id));
                                    setSelectionModel((prev: GridSelectionModel) => [...prev, ...newSelection]);
                                } else {
                                    const newSelection = selectionModel.filter((id: any) => !newSelectionModel.includes(id));
                                    setSelectionModel((prev: GridSelectionModel) => prev.filter((id: any) => !newSelection.includes(id)));
                                }
                            }}

                        />
                    </div>
                </div>
                )
            }
            <div className='AddStudentDialog-student-selected-container'>
                {selectionModel.map((id) => {
                    const row = originalRows.find((r) => r.id === id);
                    return (
                        <div className='AddStudentDialog-student-selected flex-center gap-dot25' key={id}>
                            <p className='elicpse' title={row?.id + '\n' + row?.firstName}>{row?.id} {row?.firstName}</p>
                            <div style={{ display: 'flex', gap: '0.25rem' }}>
                                <button className='ProgressDialog-delete-file-btn' onClick={() => handleOnClickDelete(id)} >
                                    <img src={deleteIcon} alt="deleteIcon" />
                                </button>
                            </div>
                        </div>
                    );
                })

                }
            </div>
        </div>
    )
}
